import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const BlogSectionWrapper = styled.section`
  padding: 80px 0 120px;
  overflow: hidden;
  @media (max-width: 990px) {
    padding-bottom: 80px;
  }
  @media (max-width: 767px) {
    padding-top: 40px;
  }

  .glide {
    max-width: 954px;
    margin: 0 auto;
    .glide__slide {
      display: flex;
      margin-bottom: 40px;
      @media only screen and (max-width: 991px) {
        padding-top: 30px;
      }
      @media only screen and (max-width: 680px) {
        flex-direction: column-reverse;
      }
    }
    .glide__controls {
      position: relative;
      bottom: 0;
      .reusecore__button {
        &:hover {
          color: ${themeGet('colors.quoteText', '#343d48')};
        }
      }
    }
  }
`;

const BlogImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const BlogPostPaper = styled.div`
  padding: 20px;
  margin-top: 20px;
  border-radius: 10px;
`;

const ExtraImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 20px 0;
`;


export { BlogSectionWrapper, BlogImage, BlogPostPaper, ExtraImage };
